import { render } from "./HorizontalList.vue?vue&type=template&id=58006402&scoped=true"
const script = {}

import "./HorizontalList.vue?vue&type=style&index=0&id=58006402&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58006402"]])

export default __exports__